export const iconFontAwesomeSportsFitnessVolleyball = (
	<i className="fa-solid fa-volleyball"></i>
);
